// useCalendarEvents.js

import { useMemo } from 'react';

import {
  buildCalendarEventItems,
  isCalendarEventItemVisible,
} from 'views/calendar/shared/calendarUtils';

const useCalendarEvents = ({ nodes, dateFields, typeKey, eventItems, rangeStart, rangeEnd }) => {
  return useMemo(
    () => {
      const items = Array.isArray(eventItems)
        ? eventItems
        : buildCalendarEventItems({ nodes, dateFields, typeKey, rangeStart, rangeEnd });

      return items.filter((item) => isCalendarEventItemVisible(item, { typeKey }));
    },
    [eventItems, nodes, dateFields, typeKey, rangeStart, rangeEnd]
  );
};

export default useCalendarEvents;
